export default __webpack_public_path__ + "static/media/move_fast_reject2.5f2c5c79.svg";